import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import Changes from "../../common/Changes";
import GameTypes from "../../common/GameTypes";
import InputSelect from "../../common/InputSelect";

import {
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import Loader from "../../common/loader/Loader";

export default forwardRef(function ProfileGameType(props, ref) {
  // const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    label: {
      fontSize: 12,
      margin: 0,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  /**
   * DATA
   */
  const [loading, setLoading] = useState(true);
  const [gameTypeInfo, setGameTypeInfo] = useState({});
  const [gameTypeInfoSport, setGameTypeInfoSport] = useState({});

  /**
   * FILTERS
   */
  const [idGameType, setIdGameType] = React.useState(1);

  const [idSport, setIdSport] = React.useState("NFL  ");
  const sports = useMemo(() => [
    {
      value: "NFL  ",
      text: "NFL",
    },
    {
      value: "CFB  ",
      text: "CBB",
    },
    {
      value: "NBA  ",
      text: "NBA",
    },
    {
      value: "CBB  ",
      text: "CBB",
    },
  ]);

  const [wagerType, setWagerType] = React.useState(1);
  const onWagerTypeChanged = useCallback((w) => setWagerType(w), []);
  const wagerTypes = useMemo(() => [
    {
      value: 1,
      text: "Parlay",
    },
    {
      value: 2,
      text: "Teaser",
    },
  ]);

  /**
   * REQUESTS
   */
  const getGameTypeInfo = useCallback(async () => {
    const { idProfile } = props.Profile;
    const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileGameType_GetInfo?idProfile=${idProfile}&idGameType=${idGameType}`;
    return axios({
      method: "get",
      url,
      /*  REPLACE WITH SELECT DATA */
    })
      .then((response) => response.data)
      .then((gameTypeInfo) => {
        setGameTypeInfo(gameTypeInfo);
      });
  }, [idGameType]);

  const getGameTypeInfoSport = useCallback(async () => {
    const { idProfile } = props.Profile;
    const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileGameTypeSport_GetInfo?idProfile=${idProfile}&idGameType=${idGameType}&idSport=${idSport}&wagerType=${wagerType}`;
    return axios({
      method: "get",
      url,
      /*  REPLACE WITH SELECT DATA */
    })
      .then((response) => response.data)
      .then((gameTypeInfoSport) => {
        setGameTypeInfoSport(gameTypeInfoSport);
      });
  }, [props.Profile, idGameType, idSport, wagerType]);

  useEffect(() => {
    Promise.all([getGameTypeInfo(), getGameTypeInfoSport()]).then(() => {
      setLoading(false);
    });
  }, []);

  const onIdGameTypeChanged = useCallback((g) => setIdGameType(g), []);
  const onIdSportChanged = useCallback((s) => setIdSport(s), []);

  useEffect(() => {
    getGameTypeInfo();
  }, [getGameTypeInfo]);

  useEffect(() => {
    getGameTypeInfoSport();
  }, [getGameTypeInfoSport]);

  const updateGameType = useCallback(() => {
    const { idProfile } = props.Profile;

    const gameTypeInfoUrl = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileGameType_Update`;
    let gameTypeInfoUpdate = {
      ...gameTypeInfo,
      IdProfile: idProfile,
      IdGameType: idGameType,
      IdUser: userInfo.userId,
    };

    const gameTypeInfoSportUrl = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileGameTypeSport_Update`;
    const gameTypeInfoSportUpdate = {
      ...gameTypeInfoSport,
      IdProfile: idProfile,
      IdGameType: idGameType,
      IdSport: idSport,
      Wagertype: wagerType,
      IdUser: userInfo.userId,
    };

    Promise.all([
      axios({
        method: "post",
        url: gameTypeInfoUrl,
        data: gameTypeInfoUpdate,
      }),
      axios({
        method: "post",
        url: gameTypeInfoSportUrl,
        data: gameTypeInfoSportUpdate,
      }),
    ]).then(() => {
      getGameTypeInfo();
      getGameTypeInfoSport();
    });
  }, [gameTypeInfo, gameTypeInfoSport, idGameType, idSport, userInfo, props]);

  useImperativeHandle(ref, () => ({
    updateGameType,
  }));

  const handleChangeInfo = (event, key, value) => {
    setGameTypeInfo({
      ...gameTypeInfo,
      [key]: event ? event.target.value : value,
    });
  };

  const handleChangeInfoSport = (event, key, value) => {
    setGameTypeInfoSport({
      ...gameTypeInfoSport,
      [key]: event ? event.target.value : value,
    });
  };

  return (
    <div className="flex flex-row gap-4">
      <GameTypes
        style={{ marginTop: -250 }}
        isEasy={true}
        setGameTypeOnMem={onIdGameTypeChanged}
      />

      {!loading ? (
        <div className="flex flex-col flex-1 col-span-2 gap-4">
          <h3>Free Play Options</h3>
          <div className="grid flex-1 grid-cols-2 gap-4">
            <div className="grid flex-1 grid-cols-2 gap-4">
              <div className="flex-1 col-span-1 vertical-options !gap-0">
                <h3>NFL</h3>
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowON3NFL}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowON3NFL",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow On 3"
                />

                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowOFF3NFL}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowOFF3NFL",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow Off 3"
                />

                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowON7NFL}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowON7NFL",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow On 7"
                />

                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowOFF7NFL}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowOFF7NFL",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow Off 7"
                />
              </div>
              <div className="flex-1 col-span-1 vertical-options !gap-0">
                <h3>College Football</h3>
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowON3CFB}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowON3CFB",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow On 3"
                />

                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowOFF3CFB}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowOFF3CFB",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow Off 3"
                />

                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowON7CFB}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowON7CFB",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow On 7"
                />

                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.allowOFF7CFB}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "allowOFF7CFB",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Allow Off 7"
                />
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <div className="vertical-options !gap-4 !flex-row">
                <TextField
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Free ½ points"
                  value={gameTypeInfo.freeHalfPoints}
                  onChange={(event) =>
                    handleChangeInfo(event, "freeHalfPoints")
                  }
                  variant="outlined"
                />
                <Changes
                  title={`Changes`}
                  buttonText={"Changes"}
                  params={{
                    ChangeType: 19,
                    IdSport: "",
                    Param1: props.Profile.idProfile,
                    Param2: 1,
                    Param3: -1,
                  }}
                />
              </div>
              <div className="flex-1 vertical-options !gap-0">
                <h3>Baseball</h3>
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.pL_UseWideLine}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "pL_UseWideLine",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Calc Parlays payout with Wideline"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={gameTypeInfo.useWideLine}
                      onChange={(event) => {
                        handleChangeInfo(
                          undefined,
                          "useWideLine",
                          event.target.checked
                        );
                      }}
                      color="primary"
                    />
                  }
                  label="Use Wideline"
                />
              </div>
            </div>
          </div>
          <div className="flex-1 col-span-1 horizontal-options">
            <h3>Max Times same team can be involved in bets</h3>
            <div className="flex flex-row items-center justify-start !gap-2">
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={gameTypeInfo.pL_CheckSameTeam}
                    onChange={(event) => {
                      handleChangeInfo(
                        undefined,
                        "pL_CheckSameTeam",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Check this limit on Parlay, allowing only"
              />

              <TextField
                className="!w-28"
                size="small"
                type="number"
                value={gameTypeInfo.pL_MaxSameTeam}
                onChange={(event) => handleChangeInfo(event, "pL_MaxSameTeam")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">times.</InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="flex flex-row items-center justify-start !gap-2">
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={gameTypeInfo.tL_CheckSameTeam}
                    onChange={(event) => {
                      handleChangeInfo(
                        undefined,
                        "tL_CheckSameTeam",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Check this limit on Teaser, allowing only"
              />
              <TextField
                className="!w-28"
                size="small"
                type="number"
                value={gameTypeInfo.tL_MaxSameTeam}
                onChange={(event) => handleChangeInfo(event, "tL_MaxSameTeam")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">times.</InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="flex flex-row items-center justify-start !gap-2">
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={gameTypeInfo.iL_CheckSameTeam}
                    onChange={(event) => {
                      handleChangeInfo(
                        undefined,
                        "iL_CheckSameTeam",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Check this limit on If Bets and Reverses, allowing only"
              />
              <TextField
                className="!w-28"
                size="small"
                type="number"
                value={gameTypeInfo.iL_MaxSameTeam}
                onChange={(event) => handleChangeInfo(event, "iL_MaxSameTeam")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">times.</InputAdornment>
                  ),
                }}
              />
            </div>
          </div>

          <div className="flex-1 col-span-1 vertical-options !gap-0">
            <h3>Check Limit Per Team/Total</h3>
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfo.sL_CheckMLnSpread}
                  onChange={(event) => {
                    handleChangeInfo(
                      undefined,
                      "sL_CheckMLnSpread",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Check Money Line and Spread as same play for Straight Bets"
            />

            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfo.pL_CheckMLnSpread}
                  onChange={(event) => {
                    handleChangeInfo(
                      undefined,
                      "pL_CheckMLnSpread",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Check $Line and Spread as same play for Parlays"
            />

            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfo.pL_CheckTOnTU}
                  onChange={(event) => {
                    handleChangeInfo(
                      undefined,
                      "pL_CheckTOnTU",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Check Total Over and Under as same play for Parlays"
            />

            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfo.tL_CheckTOnTU}
                  onChange={(event) => {
                    handleChangeInfo(
                      undefined,
                      "tL_CheckTOnTU",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Check Total Over and Under as same play for Teasers"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfo.rL_CheckMLnSpread}
                  onChange={(event) => {
                    handleChangeInfo(
                      undefined,
                      "rL_CheckMLnSpread",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Check $Line and Spread as same play for Reverses"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfo.rL_CheckTOnTU}
                  onChange={(event) => {
                    handleChangeInfo(
                      undefined,
                      "rL_CheckTOnTU",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Check Total Over and Under as same play for Reverses"
            />
          </div>

          <h3>Max Points for side/total combinations</h3>
          <div className="mb-3 web-options">
            <InputSelect
              variant="outlined"
              size="small"
              label="Sport"
              name="name"
              data={sports}
              placeholder="DataFormatter"
              setSelectValue={onIdSportChanged}
              startValue={idSport}
            />
            <InputSelect
              variant="outlined"
              size="small"
              label="Bet Type"
              name="name"
              data={wagerTypes}
              placeholder="DataFormatter"
              setSelectValue={onWagerTypeChanged}
              startValue={wagerType}
            />
            <Changes
              title={`Changes`}
              buttonText={"Changes"}
              params={{
                ChangeType: 25,
                IdSport: idSport,
                Param1: props.Profile.idProfile,
                Param2: 1,
                Param3: wagerType,
              }}
            />
          </div>
          <div className="flex-1 col-span-1 vertical-options !gap-0">
            <TextField
              size="small"
              type="number"
              label="Points limit"
              value={gameTypeInfoSport.maxPoints}
              onChange={(event) => handleChangeInfoSport(event, "maxPoints")}
              variant="outlined"
              inputProps={{
                step: 0.1, // allows decimal input to two decimal places
              }}
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfoSport.checkDogOver}
                  onChange={(event) => {
                    handleChangeInfoSport(
                      undefined,
                      "checkDogOver",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Dog Spread / Total Over"
            />

            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfoSport.checkDogUnder}
                  onChange={(event) => {
                    handleChangeInfoSport(
                      undefined,
                      "checkDogUnder",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Dog Spread / Total Under"
            />

            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfoSport.checkFavOver}
                  onChange={(event) => {
                    handleChangeInfoSport(
                      undefined,
                      "checkFavOver",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Fav Spread / Total Over"
            />

            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={gameTypeInfoSport.checkFavUnder}
                  onChange={(event) => {
                    handleChangeInfoSport(
                      undefined,
                      "checkFavUnder",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Fav Spread / Total Under"
            />
          </div>
        </div>
      ) : (
        <Loader></Loader>
      )}
    </div>
  );
});
